import { CategoryNamesAndIds } from '@/pages/DiscoverCategories/constants/constant';

import { urlSafeTitle } from '../urls';

/**
 * Frontend ground-truth for top-cat slug → id resolution. Use this — NOT post-search F1
 * heuristics — for any L1 the loader needs to filter by. `CategoryNamesAndIds` is scoped to the
 * Discover page's curated tile set and intentionally omits some real L1s; the entries below
 * fill that gap (and cover slug aliases like Coins' SEO slug).
 *
 * Add to this map whenever a new L1 surfaces under `/c/{slug}/` paths. Without it, the loader
 * falls back to a search-response heuristic that is fragile when the keyword fallback's items
 * happen to be categorized under a different L1 (e.g. luxury watches filed under Jewelry).
 */
const TOP_CATEGORY_SLUG_TO_ID: Readonly<Record<string, number>> = {
    'coins-currency-and-stamps': CategoryNamesAndIds.Coins,
    watches: 97,
};

/**
 * Resolves a top-level discover category slug (urlSafeTitle of display name) to category id.
 * Returns null when unknown — full browse resolution should use the category API.
 */
export const getTopCategoryIdFromSlug = (categorySlug: string): number | null => {
    const target = decodeURIComponent(categorySlug).toLowerCase();
    const fromAlias = TOP_CATEGORY_SLUG_TO_ID[target];
    if (fromAlias !== undefined) {
        return fromAlias;
    }
    for (const [name, id] of Object.entries(CategoryNamesAndIds)) {
        if (urlSafeTitle(name).toLowerCase() === target) {
            return id;
        }
    }
    return null;
};
